import { levelInchesNew } from "../utils/nominalNumbers";

export const WALL_THICKNESS_INTERIOR = levelInchesNew(3.5);
export const WALL_OFFSET_INTERIOR = levelInchesNew(WALL_THICKNESS_INTERIOR / 2);
export const ROOF_THICKNESS = levelInchesNew(8);
export const HALL_WIDTH = levelInchesNew(42);
export const GARAGE_ONE_WIDTH = levelInchesNew(96);
export const GARAGE_TWO_WIDTH = levelInchesNew(192);

export const MIN_STAIR_RISE = 7;
export const STAIR_TREAD = 11;
export const FOUNDATION_THICKNESS = levelInchesNew(6);
export const BED_MEDIUM = levelInchesNew(144);
export const BATH_DEPTH = levelInchesNew(60 + WALL_THICKNESS_INTERIOR);
export const BATH_LENGTH = levelInchesNew(144);

export const GABLE_ROOF_THICKNESS = 2;

export const BED_KING_WIDTH = levelInchesNew(76);
export const BED_QUEEN_WIDTH = levelInchesNew(60);
export const BED_FULL_WIDTH = levelInchesNew(54);
export const BED_TWIN_WIDTH = levelInchesNew(39);

export const SHELF_THICKNESS = levelInchesNew(1);
export const SHELF_HEIGHT = levelInchesNew(60);
export const SHELF_DEPTH = levelInchesNew(14);

export const REACH_CLOSET_DEPTH = levelInchesNew(30);

export const BENCH_DEPTH = levelInchesNew(18);
export const BENCH_HEIGHT = levelInchesNew(18);

export const COUNTER_DEPTH = levelInchesNew(25.5);
export const VANITY_DEPTH = levelInchesNew(21);
export const UPPER_CABINET_DEPTH = levelInchesNew(12);
// Cabinet box depth without the countertop overhang that COUNTER_DEPTH accounts for.
export const TALL_CABINET_DEPTH = levelInchesNew(24);
export const FILLER_PANEL_DEPTH = levelInchesNew(24);
export const COUNTER_HEIGHT = levelInchesNew(36.0);
export const TALL_CABINET_HEIGHT = levelInchesNew(84);
export const UPPER_CABINET_BASE = levelInchesNew(COUNTER_HEIGHT + 18);
export const UPPER_BASE_ABOVE_RANGE = levelInchesNew(COUNTER_HEIGHT + 30);
export const ISLAND_DEPTH = levelInchesNew(36);
export const CABINET_VERTICAL_OFFSET = levelInchesNew(60);
export const CLOSET_SHELF_DEPTH = levelInchesNew(16);
export const CLOSET_SHELF_HEIGHT = levelInchesNew(1.5);

export const RAFTER_DIST = levelInchesNew(18);

// universal design
export const UNIV_HALL_WIDTH = levelInchesNew(48);
export const UNIV_COUNTER_HEIGHT = levelInchesNew(28);
export const UNIV_UPPER_CABINET_BASE = levelInchesNew(UNIV_COUNTER_HEIGHT + 14);

// cabinet widths
export const CABINET_18 = levelInchesNew(18);
export const CABINET_12 = levelInchesNew(12);
export const CABINET_24 = levelInchesNew(24);
export const CABINET_30 = levelInchesNew(30);
export const CABINET_33 = levelInchesNew(33);
export const CABINET_36 = levelInchesNew(36);
export const CABINET_48 = levelInchesNew(48);

// site params
export const DRIVEWAY_DEPTH = levelInchesNew(12);
export const GROUND_LEVEL = levelInchesNew(-6);

// ridge vent
export const RIDGE_VENT = new Float64Array([
  3.823223, -3.176777, 2, -1.353553, 2, -1, 0, 1, -2, -1, -2, -1.353553, -3.823223, -3.176777, -3.779029, -3.220971,
  -1.9375, -1.379442, -1.9375, -1.025888, 0, 0.911612, 1.9375, -1.025888, 1.9375, -1.379442, 3.779029, -3.220971,
  3.823223, -3.176777,
]);

export const K_STYLE_OFFSET = 0.02;
export const K_STYLE_CAP_THICKNESS = 0.5;

export const K_STYLE = new Float64Array([
  0, 0, 0, -5.079999923706055, -3.930000066757202, -5.079999923706055, -3.930000066757202, -4.28000020980835,
  -4.374852180480957, -4.276763916015625, -5.43134880065918, -1.3700000047683716, -6, -1.3700000047683716, -6, -0.5,
  -5.329999923706055, -0.5, -5.329999923706055, -0.6001200079917908, -5.482490062713623, -0.7503499984741211,
  -5.526352882385254, -0.705826997756958, -5.392499923706055, -0.5739579796791077, -5.392499923706055, -0.5625, -5.9375,
  -0.5625, -5.9375, -1.3075000047683716, -5.43134880065918, -1.3075000047683716, -5.3726091384887695,
  -1.3486499786376953, -4.330953121185303, -4.21458101272583, -3.9295449256896973, -4.217502117156982,
  -3.867500066757202, -4.28000020980835, -3.867500066757202, -5.017499923706055, -0.0625, -5.017499923706055, -0.0625,
  0, 0, 0,
]);

export const K_STYLE_CAP = new Float64Array([
  0, 0, 0, -5.079999923706055, -3.930000066757202, -5.079999923706055, -3.930000066757202, -4.28000020980835,
  -4.374852180480957, -4.276763916015625, -5.43134880065918, -1.3700000047683716, -6, -1.3700000047683716, -6, -0.5,
  -5.329999923706055, -0.5, 0, 0,
]);

// Camera zoom (used in preview and Showroom)
export const ORTHO_MAX_ZOOM = 3.0;
export const ORTHO_MAX_ZOOM_ELEVATION_PREVIEW = 40.0;
export const ORTHO_MIN_ZOOM = 1.0;
export const ORTHO_MIN_ZOOM_ELEVATION_PREVIEW = 0.1;

// Cut plane height for floor plans. Entity relationships to this height should be treated
// per architectural standard when drawn on plans. Typically :
// - above - dashed lines
// - cut - thick lines
// - below - thin lines
export const FLOOR_PLAN_CUT_PLANE = 48;

// porch structural
export const MIN_INTERNAL_PORCH_STRUCTURE_SIZE = 1;

// window shutters
export const MIN_VALID_SHUTTER_WIDTH = 6;
export const MIN_VALID_SHUTTER_HEIGHT = 6;

// windows
export const DEFAULT_INTEGRAL_MULLION_WIDTH = 3;
export const MAX_WINDOW_GRID_DIVS = 25;
export const MIN_WINDOW_GRID_THICKNESS = 0.25;
